import React from "react";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import shiftup2 from "../../Assets/Projects/shiftup2.gif";
import travis_county from "../../Assets/Projects/Travis_County.png";
import austin_city from "../../Assets/Projects/Austin_City.png";
import san_marcos from "../../Assets/Projects/San_Marcos_Library.png";
import crimson_ark from "../../Assets/Projects/crimson_ark.png";
import urban_alchemy from "../../Assets/Projects/Urban-Alchemy.jpg"
import code_soil from "../../Assets/Projects/code&soil.png"
import montopolis from "../../Assets/Projects/Montopolis.jpg"
import unrulr from "../../Assets/Projects/Unrulr.png"
import insight from "../../Assets/Projects/Insight.png"
import mido from "../../Assets/Projects/Mido.png"
import techkids from "../../Assets/Projects/TechKidsUltd.png"
import ldg from "../../Assets/Projects/LDG.png"
import centro from "../../Assets/Projects/Centro.png"
import assist from "../../Assets/Projects/Assist.png"
import favrhood from "../../Assets/Projects/favrhood_logo1.png"


function Toolstack() {
  const { t } = useTranslation();

  const logoAlt = (name) => t("aboutPartners.a11y.partnerLogoAlt", { name });
  const partners = [
    { name: "Travis County", image: travis_county },
    { name: "City of Austin", image: austin_city },
    { name: "ShiftUp", image: shiftup2 },
    { name: "San Marcos Public Library", image: san_marcos },
    { name: t("aboutPartners.partnerNames.crimsonArkStudio"), image: crimson_ark },
    { name: "Favrhood", image: favrhood },
    { name: "Urban Alchemy", image: urban_alchemy },
    { name: "Code & Soil", image: code_soil },
    { name: "Montopolis", image: montopolis },
    { name: "Unrulr", image: unrulr },
    { name: "Insight", image: insight },
    { name: "Mido", image: mido },
    { name: "TechKidsUltd", image: techkids },
    { name: "LDG", image: ldg },
    { name: "Centro", image: centro },
    { name: "Assist", image: assist },
  ];

  return (
    <Row className="partners-logo-grid" aria-label="Partner logos">
      {partners.map((partner) => (
        <Col xs={6} sm={4} md={3} lg={2} key={partner.name} className="partners-logo-col">
          <div className={`policy-card partners-logo-card h-100${partner.name === "Travis County" ? " partners-logo-card--travis" : ""}`}>
            <div className={`partners-logo-frame${partner.name === "Travis County" ? " partners-logo-frame--travis" : ""}`}>
              <img
                src={partner.image}
                alt={logoAlt(partner.name)}
                className={`partners-logo-image${partner.name === "Travis County" ? " partners-logo-image--travis" : ""}`}
                loading="lazy"
              />
            </div>
            <p className="partners-logo-name">{partner.name}</p>
          </div>
        </Col>
      ))}
    </Row>
  );
}

export default Toolstack;
